import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import React from 'react'

const useWidgetLabelStyles = makeStyles((theme: Theme) => ({
    widgetLabel: {
        textTransform: 'uppercase',
        fontSize: pxToRem(12),
        [theme.breakpoints.down('sm')]: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 100,
        },
    },
    collapsedWidgetLabelPadding: {
        paddingTop: theme.spacing(0.625),
        paddingBottom: theme.spacing(3.75),
    },
    expandedWidgetLabelPadding: {
        paddingTop: theme.spacing(0.25),
        paddingBottom: 0,
    },
    'widgetLabelAlignment-right': {
        textAlign: 'right',
    },
    'widgetLabelAlignment-left': {
        textAlign: 'left',
    },
    'widgetLabelAlignment-center': {
        textAlign: 'center',
    },
}))

export type WorkspaceActionBarWidgetLabelOptions = {
    text: string
    alignment?: 'left' | 'center' | 'right'
}

export type WorkspaceActionBarWidgetLabelAlignmentTypes =
    | 'widgetLabelAlignment-center'
    | 'widgetLabelAlignment-right'
    | 'widgetLabelAlignment-left'

export interface WorkspaceActionBardWidgetLabelProps {
    isCollapsed?: boolean
    label?: string | WorkspaceActionBarWidgetLabelOptions
}

const WorkspaceActionBarWidgetLabel: React.FC<WorkspaceActionBardWidgetLabelProps> = ({
    isCollapsed = false,
    label = '',
}) => {
    const widgetLabelClasses = useWidgetLabelStyles()
    const labelText = React.useMemo(
        () => (typeof label === 'string' ? label : label.text),
        [label]
    )
    const labelOptions = React.useMemo(
        () => (typeof label !== 'string' ? label : null),
        [label]
    )

    return (
        <Typography
            className={clsx(
                'widgetLabel',
                widgetLabelClasses.widgetLabel,
                isCollapsed
                    ? widgetLabelClasses.collapsedWidgetLabelPadding
                    : widgetLabelClasses.expandedWidgetLabelPadding,
                [
                    widgetLabelClasses[
                        `widgetLabelAlignment-${
                            labelOptions?.alignment ?? 'center'
                        }` as WorkspaceActionBarWidgetLabelAlignmentTypes
                    ],
                ]
            )}
        >
            {labelText}
        </Typography>
    )
}

export default WorkspaceActionBarWidgetLabel
